<template lang="pug">
.container
  page-header(
    :disable-back="true"
    :disable-home="true"
  )
  .wrapper: .content: div
    .menu-link: router-link(to="/info") 
      | Informationen zum Wettbewerb
    .menu-link: router-link(to="/list") 
      | Wettbewerbs-Entwürfe
    .menu-link: router-link(to="/gallery") 
      | Foto-Galerie
    .menu-link: router-link(to="/video") 
      | Impressionen der Jurysitzung
</template>

<script>
export default {
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.menu-link {
  border-width: 0 0 0 6px;
  border-left-style: solid;
  padding-left: 30px;
  -o-border-image: linear-gradient(180deg, #00ffb9, #00e6dc);
  border-image: -webkit-gradient(linear, left top, left bottom, from(#00ffb9), to(#00e6dc));
  border-image: linear-gradient(180deg, #00ffb9, #00e6dc);
  border-image-slice: 1;
}
</style>
